<template>
    <header id="elle-header" class="elle-header">
        <div class="elle-header--wrapper">
            <div class="l-col">
                <NuxtLinkLocale :to="homePath" title="Elle Midwives" class="elle-logo">Elle Midwives</NuxtLinkLocale>
            </div>

            <div class="m-col">
                <CommonMenu v-show="isDesktop" />
                <CommonMenuMobile v-show="!isDesktop" />
            </div>

            <div class="r-col">
                <div class="languages">
                    <template v-if="isDesktop">
                        <span v-for="item in locales" :key="item.code" class="language">
                            <NuxtLink :to="switchLocalePath(item.code)" active-class="active">
                                {{ item.code }}
                            </NuxtLink>
                        </span>
                    </template>
                    <span v-else-if="inactiveLocale.code !== locale" class="language">
                        <NuxtLink :to="switchLocalePath(inactiveLocaleCode)">
                            {{ inactiveLocale.code }}
                        </NuxtLink>
                    </span>
                </div>
                <button
                    v-show="!isDesktop"
                    type="button"
                    class="toggle-mobile-menu"
                    :class="{ active: mobileMenu }"
                    :title="mobileMenuTitle"
                    :aria-label="mobileMenuTitle"
                    :aria-expanded="mobileMenu ? 'true' : 'false'"
                    @click="mobileMenu = !mobileMenu"
                >
                    <span />
                    <span />
                    <span />
                    <span />
                </button>
                <div v-show="isDesktop" v-if="!!settings[0]?.headerLinks?.length" class="buttons">
                    <UiLink :link="settings[0]?.headerLinks[0]" :style="'transparent w-border'" />
                </div>
            </div>
        </div>
    </header>
</template>

<script setup lang="ts">
import type { CmsItem } from '~/types/cms';

const { locale, locales, t } = useI18n();
const switchLocalePath = useAppSwitchLocalePath();
const settingsData = useSettingsData();
const homePath = computed(() => (locale.value === 'nl' ? '/' : `/${locale.value}`));
const settings = computed<CmsItem[]>(() => settingsData.value.filter(item => item.siteId == useSiteId()));
const inactiveLocale = computed(
    () => locales.value.find(item => item.code !== locale.value) ?? ({ code: locale.value } as (typeof locales.value)[number])
);
type LocaleCode = Parameters<typeof switchLocalePath>[0];
const inactiveLocaleCode = computed(() => (inactiveLocale.value?.code ?? locale.value) as LocaleCode);

const isDesktop = useMediaQuery('(min-width: 1368px)');
const mobileMenu = useToggleMobileMenu();
const mobileMenuTitle = computed(() => (mobileMenu.value ? t('header.label_menu_close') : t('header.label_menu_open')));
</script>
